import { StatementFormatter } from './Formatters/StatementFormatter';
export class Statement {
    constructor() {
        this.AccountId = null;
        this.InstrumentStr = null;
        this.Date = null;
        this.OperationTypeId = null;
        this.OperationType = null;
        this.OperationID = null;
        this.Amount = null;
        this.OpenPrice = null;
        this.ClosePrice = null;
        this.Quantity = null;
        this.TradeOpeningDate = null;
        this.OpenCrossPrise = null;
        this.PositionID = null;
        this.TradeId = null;
        this.Details = null;
        this._currency = null;
    }
    get Currency() {
        var _a, _b;
        if (isValidString(this._currency)) {
            return this._currency;
        }
        return (_b = (_a = this.Account) === null || _a === void 0 ? void 0 : _a.BaseCurrency) !== null && _b !== void 0 ? _b : null;
    }
    set Currency(value) {
        this._currency = value;
    }
    get Account() {
        return StatementFormatter.Account(this);
    }
    set Account(account) {
        var _a;
        this.AccountId = (_a = account === null || account === void 0 ? void 0 : account.ID) !== null && _a !== void 0 ? _a : null;
    }
    Dispose() {
        this.AccountId = null;
        this.InstrumentStr = null;
        this._currency = null;
    }
}
